import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { BackButton } from "../assets/Icons";
import Groups from "./Groups";
import { SSO_URL } from "../env";
import { CREATE_NEW_CHANNEL, FETCH_ENUM_TYPES, GET_DIRECTORY_LIST, GET_GROUP_LIST } from "../apiClient/apiEndpoints";
import apiClient from "../apiClient";

const ChannelCreate = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [channelTypes, setChannelTypes] = useState([]);
  const [directories, setDirectories] = useState([]);
  const [newChannelDetails, setNewChannelDetails] = useState({
    name: null,
    type: null,
    directory: null,
    group: null,
  });

  const fetchDirectories = async () => {
    try {
      const details = await apiClient.get(`${SSO_URL}${GET_DIRECTORY_LIST}`);
      setDirectories(details);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchChannelsType = async () => {
    try {
      let data = await apiClient.get(`${SSO_URL}${FETCH_ENUM_TYPES}/channelType`);
      const { PRIMARY, ...others } = data;
      setChannelTypes(Object.keys(others));
    } catch (error) {
      console.log(error);
    }
  };

  const handleResetData = () => {
    setNewChannelDetails({
      name: null,
      type: null,
      directory: null,
      group: null,
    });
  };

  const validateDetails = () => {
    let errorStatus = false;
    if (!newChannelDetails.name) errorStatus = true;
    if (!newChannelDetails.type) errorStatus = true;
    if (!newChannelDetails.directory) errorStatus = true;
    if (!newChannelDetails.group) errorStatus = true;
    return errorStatus;
  };

  const handleCreateChannel = async () => {
    setError(null);
    setSuccess(null);
    if (loading) return;
    try {
      if (validateDetails()) {
        setError("Kindly fill all fields.");
        return;
      }
      setLoading(true);
      let bodyData = {
        group: newChannelDetails.group,
        channel: {
          name: newChannelDetails.name,
          type: newChannelDetails.type.value,
        },
        directory: newChannelDetails.directory.value,
      };
      await apiClient.post(`${SSO_URL}${CREATE_NEW_CHANNEL}`, bodyData);
      setSuccess("Channel created successfully.");
      handleResetData();
      navigate("/dashboard/channels");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (state?.directoryId && directories?.length > 0) {
      const currentDir = directories.find((item) => item.uuid === state.directoryId);
      setNewChannelDetails((prev) => ({ ...prev, directory: { label: currentDir.name, value: currentDir.uuid } }));
    }
  }, [state?.directoryId, directories?.length]);

  useEffect(() => {
    fetchDirectories();
    fetchChannelsType();
  }, []);

  return (
    <div className="container-fluid p-4 pt-2">
      <button className="backbtn cursor-pointer mt-2" onClick={() => navigate(-1)} title="Back">
        <BackButton />
        Back
      </button>
      <div className="add-info">
        <div className="row">
          <div className="col-md-6">
            <div className="standardinput mt-3">
              <label>
                Channel Name <span className="ps-1">*</span>
              </label>
              <input
                placeholder="New Channel Name"
                autoComplete="off"
                name="moduleName"
                id="moduleName"
                className="input form-control"
                type="text"
                onChange={(e) => {
                  setNewChannelDetails((prev) => ({ ...prev, name: e.target.value }));
                }}
              />
              {!newChannelDetails?.name && <p className="error"> Name is required. </p>}
            </div>

            <div className="standardinput mt-2 ">
              <label className="mb-2">
                Select Type <span>*</span>
              </label>
              <div className="forselect-input">
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    colors: {
                      ...theme.colors,
                      primary50: "#ca373c50",
                      primary25: "#ca373c50",
                      primary: "#ca373c70",
                      danger: "#000000",
                      neutral30: "#00000050",
                    },
                  })}
                  onChange={(e) => setNewChannelDetails((prev) => ({ ...prev, type: e }))}
                  options={channelTypes?.map((e) => ({ label: e, value: e }))}
                  value={newChannelDetails.type}
                />
              </div>
              {!newChannelDetails.type && <p className="error"> Select Channel type. </p>}
            </div>

            <div className="standardinput mt-2 ">
              <label className="mb-2">
                Select Directory <span>*</span>
              </label>
              <div className="forselect-input">
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    colors: {
                      ...theme.colors,
                      primary50: "#ca373c50",
                      primary25: "#ca373c50",
                      primary: "#ca373c70",
                      danger: "#000000",
                      neutral30: "#00000050",
                    },
                  })}
                  onChange={(e) => setNewChannelDetails((prev) => ({ ...prev, directory: e }))}
                  options={directories?.map((e) => ({ label: e.name, value: e.uuid }))}
                  value={newChannelDetails.directory}
                />
              </div>
              {!newChannelDetails.directory && <p className="error"> Select Directory. </p>}
            </div>
          </div>

          <div className="col-md-6">
            <div className="footerbtn mt-4">
              <button className="cancel"> Cancel </button>
              {loading ? (
                <button className="loading save">
                  {" "}
                  <svg viewBox="25 25 50 50">
                    {" "}
                    <circle r="20" cy="50" cx="50"></circle>{" "}
                  </svg>{" "}
                </button>
              ) : (
                <button className="save" onClick={handleCreateChannel}>
                  Save
                </button>
              )}
            </div>
            {error && <p className="channelError">{error}</p>}
            {success && <p className="channelSuccess">{success}</p>}
          </div>
        </div>
        
        <div className="col-12">
          <Groups
            setSearch={setSearch}
            search={search}
            setNewChannelDetails={setNewChannelDetails}
            newChannelDetails={newChannelDetails}
          />
        </div>
      </div>
    </div>
  );
};

export default ChannelCreate;
